<template>
  <div>
    <div class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
    </div>
    <!-- title -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.title}}</div>
      <input type="text" class="input" v-model="info.space">
    </div>
    <!-- //title -->
    <!-- submit code
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.submit}}</div>
      <p class="sysMessage">
        <router-link v-if="userRole === 'admin'"
          :to="{name: 'admin', params: {admin: 'codelist'}}"
          data-nav="admin">
          {{`[${locale.submit_category_setting}] ${locale.nav_admin} > ${locale.admin_codelist}`}}
        </router-link>
        <span v-else>{{`[${locale.submit_category_setting}] ${locale.message_admin_only}`}}</span>
      </p>
      <select v-model="info.submitTo" class="input">
        <option value="">{{locale.admin_codelist}}</option>
        <option v-for="code in codeList" :key="code.id" :value="code.id">{{code.label}}</option>
      </select>
    </div>
    //submit code -->
    <!-- load page -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.reservation_load_page}}</div>
      <p class="sysMessage">{{locale.mesage_reservation_load_page}}</p>
      <span class="checkbox">
        <input type="checkbox" id="link_page" v-model="info.linkedPage" @change="pageLink">
        <label for="link_page">{{locale.use_import}}</label>
      </span>
      <div v-if="info.linkedPage" class="mt10">
        <div v-if="info.linkInfo.title">{{info.linkInfo.title}}</div>
        <div v-else>{{locale.message_reservation_page_select}}</div>
        <button type="button" class="btn btnFull mt10" @click="loadPageLayer = true">{{locale.select_page}}</button>
      </div>
    </div>
    <!-- //load page -->
    <!-- disabled reservation -->
    <div class="innerItem">
      <div class="label mb5 setLabel">예약 설정</div>
      <div class="mb10">
        <span class="checkbox">
          <input type="checkbox" id="reservation_disabled" v-model="info.disabled">
          <label for="reservation_disabled">{{locale.reservation_disabled}}</label>
        </span>
      </div>
      <div class="mb10">
        <span class="checkbox">
          <input type="checkbox" id="reservation_multiple" v-model="info.multiple">
          <label for="reservation_multiple">{{locale.reservation_multiple}}</label>
        </span>
      </div>
    </div>
    <!-- 예약 고객 타입 -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{ locale.reservation_user_settings }}</div>
      <p class="sysMessage">{{ locale.message_reservation_user_settings }}</p>
      <div class="mb5">
        <span class="checkbox radio">
          <input type="radio" name="reservation_available_type" id="reservation_available_ota" v-model="info.availableType" value="ota">
          <label for="reservation_available_ota">{{ locale.staying_guest }}</label>
        </span>
      </div>
      <div class="mb5">
        <span class="checkbox radio">
          <input type="radio" name="reservation_available_type" id="reservation_available_package" v-model="info.availableType" value="package">
          <label for="reservation_available_package">투숙객(패키지)</label>
        </span>
      </div>
      <div class="mb5">
        <span class="checkbox radio">
          <input type="radio" name="reservation_available_type" id="reservation_available_rid" v-model="info.availableType" value="rid">
          <label for="reservation_available_rid">{{ locale.planning_stay_guest }}</label>
        </span>
      </div>
      <div>
        <span class="checkbox radio">
          <input type="radio" name="reservation_available_type" id="reservation_available_visitor" v-model="info.availableType" value="visitor">
          <label for="reservation_available_visitor">{{ locale.non_staying_guest }}</label>
        </span>
      </div>
    </div>
    <!-- //예약 제한 설정 -->
    <div v-if="info.availableType !== 'visitor'" class="innerItem">
      <div class="label mb5 setLabel">{{ locale.reservation_restrict_settings }}</div>
      <div class="mb10">
        <div class="mb10">
          <span class="checkbox">
            <input type="checkbox" id="reservation_limit_per_active" v-model="info.limitPer.active">
            <label for="reservation_limit_per_active">{{ locale.limit_number_period }}</label>
          </span>
        </div>
        <div v-if="info.limitPer.active" class="flexBox">
          <div class="flexInner">
            <span class="checkbox radio">
              <input type="radio" name="reservation_limit_per_type" id="reservation_limit_per_night" v-model="info.limitPer.type" value="night">
              <label for="reservation_limit_per_night">{{ locale.limitper_type_night }}</label>
            </span>
            <div>
              <span class="checkbox radio">
              <input type="radio" name="reservation_limit_per_type" id="reservation_limit_per_ota" v-model="info.limitPer.type" value="ota">
              <label for="reservation_limit_per_ota">{{ locale.limitper_type_ota }}</label>
            </span>
            </div>
          </div>
          <div class="flexInner">
            <input type="text" class="input sizeS" v-model="info.limitPer.limit" /> {{ locale.times }}
          </div>
        </div>
        <p v-if="info.limitPer.active && info.limitPer.type" class="sysMessage">{{ limitPerExample }}</p>
      </div>
      <div class="mb10">
        <span class="checkbox">
          <input type="checkbox" id="reservation_limit_per_day" v-model="info.limitPerDay">
          <label for="reservation_limit_per_day">{{ locale.limitper_day_enabled }}</label>
        </span>
      </div>
    </div>
    <!-- //disabled reservation -->
    <div v-if="loadPageLayer" class="layer setLinkLayer">
      <div class="inner">
        <button type="button" class="btnClose" @click="closeLinkLayer"><span class="blind">close</span></button>
        <SetLink
          :link="info.linkInfo"
          :fix="'page'"
          @sendInfo="sendInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import DATE from '@/common/date'
import SetLink from '@/components/Util/SetLink'

export default {
  name: 'SetReservationItem',
  props: [
    'locale',
    'lang',
    'info'
  ],
  components: {
    SetLink
  },
  computed: {
    codeList () {
      const codes = this.$store.getters['admin/submitCodeList']
      const list = codes.filter(x => x.id !== 'system_amenity')
      return list
    },
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    limitCount () {
      const day = 3
      const night = 2
      const limitType = this.info.limitPer.type
      const limitCount = this.info.limitPer.limit
      return limitType === 'night'
        ? night * limitCount
        : limitType === 'ota'
          ? limitCount
          : 0
    },
    limitPerExample () {
      const message = this.locale.message_example_limitper_type
      const count = this.limitCount
      return message && message.replace('{{var}}', count)
    }
  },
  created () {
    this.$store.dispatch('admin/getCodes')
  },
  data () {
    return {
      loadPageLayer: false,
      loadLinkInfo: false
    }
  },
  methods: {
    pageLink (e) {
      const isLinked = e.target.checked
      this.$emit('isLoadPage', isLinked)
    },
    closeLinkLayer () {
      this.loadLinkInfo = true
      this.loadPageLayer = false
    },
    sendInfo (data) {
      this.info.linkInfo = data
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss" scoped>
.setLinkLayer .inner {
  max-width: 400px;
}
.flexBox {
  align-items: center;
  margin: 0 0 10px;
  .flexInner {
    padding: 0;
  }
}
</style>
